/* eslint-disable react/jsx-pascal-case */
import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge, Checkbox, Button } from './ot'

import BaseCardView1_1 from './base_card_view_1_1'
import BaseCardView1_2 from './base_card_view_1_2'
import BaseCardView1_3 from './base_card_view_1_3'
import BaseCardView1_4 from './base_card_view_1_4'
import BaseCardView1_5 from './base_card_view_1_5'
import BaseCardView1_6 from './base_card_view_1_6'
import BaseCardView1_7 from './base_card_view_1_7'
import BaseCardView1_8 from './base_card_view_1_8'
import {
    Eye,
    MousePointer,
    FileText,
    TrendingUp,
    Edit, Share, Download,
} from "lucide-react"

const BaseCardView1 = ({
    showComponent = [
        "BaseCardView1_1",
        "BaseCardView1_2",
        "BaseCardView1_3",
        "BaseCardView1_4",
        "BaseCardView1_5",
        "BaseCardView1_6",
        "BaseCardView1_7",
        "BaseCardView1_8",
    ],
    baseCardView1_1Props = {
        checked: false,
        onCheckedChange: () => { }
    },
    baseCardView1_2Props = {
        src: null,
        file_id: null,
    },
    baseCardView1_3Props = {
        value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
    },
    baseCardView1_4Props = {
        value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
    },
    baseCardView1_5Props = {
        stats: [
            {
                value: 1250,
                label: "瀏覽次數",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
                icon: <Eye className="h-4 w-4 text-blue-500" />
            },
            {
                value: 45,
                label: "撰寫文案",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
                icon: <FileText className="h-4 w-4 text-green-500" />


            },
            {
                value: 320,
                label: "點擊次數",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
                icon: <MousePointer className="h-4 w-4 text-purple-500" />

            },
            {
                value: 28,
                label: "複製次數",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
                icon: <TrendingUp className="h-4 w-4 text-orange-500" />

            },
        ]
    },
    baseCardView1_6Props = {
        badges: [
            {
                label: "王小明",
                variant: "outline",
                className: ""
            },
            {
                label: <><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <path d="M8 11h8" />
                    <path d="M8 15h8" />
                    <path d="M8 7h8" />
                </svg>2025-05-30</>,
                variant: "outline",
                className: ""
            },
        ]
    },
    baseCardView1_7Props = {
        children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
    },
    baseCardView1_8Props = {
        buttons: [
            <Button variant="outline" className="flex-1">
                <Eye className="h-4 w-4 mr-1" />
                查看
            </Button>,
            <Button className="flex-1">
                <Edit className="h-4 w-4 mr-1" />
                複製文案內容並編輯
            </Button>,
            <Button variant="ghost" size="sm">
                <Share className="h-4 w-4 mr-1" />
                分享
            </Button>,
            <Button variant="ghost" size="sm">
                <Download className="h-4 w-4 mr-1" />
                匯出
            </Button>,
            <Button variant="ghost" size="sm" className="text-red-600">
                刪除
            </Button>,
        ],
        buttonGroupsColumnsCount: [2, 3],
    },


}, ref) => {

    return (
        <>
            <div className="border rounded-lg overflow-hidden bg-white">
                <div className="relative">
                    {showComponent.includes("BaseCardView1_1") && (
                        <BaseCardView1_1 {...baseCardView1_1Props} />
                    )}
                    {showComponent.includes("BaseCardView1_2") && (
                        <BaseCardView1_2 {...baseCardView1_2Props} />
                    )}
                </div>
                <div className="p-4">
                    {showComponent.includes("BaseCardView1_3") && (
                        <BaseCardView1_3 {...baseCardView1_3Props} />
                    )}
                    {showComponent.includes("BaseCardView1_4") && (
                        <BaseCardView1_4 {...baseCardView1_4Props} />
                    )}
                    {/* 統計數據區域 */}
                    <div className="grid grid-cols-1   mt-3  ">
                        {showComponent.includes("BaseCardView1_5") && (
                            <BaseCardView1_5 {...baseCardView1_5Props} />
                        )}
                    </div>
                    {/* badges */}
                    {showComponent.includes("BaseCardView1_6") && (
                        <BaseCardView1_6 {...baseCardView1_6Props} />
                    )}
                    {showComponent.includes("BaseCardView1_7") && (
                        <BaseCardView1_7 {...baseCardView1_7Props}  >
                            {baseCardView1_7Props?.children}
                        </BaseCardView1_7>
                    )}
                    {showComponent.includes("BaseCardView1_8") && (
                        <BaseCardView1_8 {...baseCardView1_8Props} />
                    )}
                </div>
            </div>


        </>
    )
}

export default BaseCardView1
